<template>
  <v-dialog v-model="dialogVisible" :max-width="width_form_keyword" max-height="auto">
    <v-card>
      <v-card-title><span class="text-h6">Update Keyword</span> 
        <span class="name_topic">Topic: {{ name_topic_dialog }}</span> </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-flex lg7>
            </v-flex>
            <v-flex lg5>
                <v-text v-show=collect_news_val style="margin-left: 18px !important;" >
                  <v-icon> mdi-web</v-icon>
                </v-text>
                <v-text  v-show=collect_twit_val style="margin-left: 29px !important;">
                  <v-icon>mdi-twitter</v-icon>
                </v-text>
                <v-text v-show=collect_ytb_val style="margin-left: 28px !important;">
                  <v-icon>mdi-youtube</v-icon>
                </v-text>
                <v-text v-show=collect_tiktok_val style="margin-left: 29px !important;">
                  <v-icon>fa-brands fa-tiktok</v-icon>
                </v-text>
                <v-text v-show=collect_ig_val style="margin-left: 29px !important;">
                  <v-icon>mdi-instagram</v-icon>
                </v-text>
                <v-text v-show=collect_fb_val style="margin-left: 29px !important;">
                  <v-icon>mdi-facebook</v-icon>
                </v-text>
            </v-flex>
          <v-row class="ma-0 pa-0 ml-3 mt-2" v-for="(item, index) in item_edit_keyword_dinamis" :key="index">
            <v-flex lg7>
              <v-text-field outlined dense v-model="item.keywordname" label="Keywords"  :disabled="keywordstatus === 0"></v-text-field>
            </v-flex>
            <v-flex lg5>
              <v-btn 
              v-show=collect_news_val 
                  class="mx-2 elevation-0" 
                  dark 
                  outlined 
                  icon 
                  :color="collect_news_val == false ? 'grey' : '#0471A5'"  
                  @click="collect_news_val  !== false && $emit('toggle-collection', item, index, 'NEWS')"
                >
                  <v-icon class="rounded-icon">{{ item.checknews == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
              </v-btn>
              <v-btn 
              v-show=collect_twit_val 
                  class="mx-2 elevation-0" 
                  dark 
                  outlined 
                  icon 
                  :color="collect_twit_val === false ? 'grey' : '#0471A5'"  
                  @click="collect_twit_val !== false && $emit('toggle-collection', item, index, 'TWITTER')"
                >
                  <v-icon class="rounded-icon">{{ item.checktwet == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
              </v-btn>
              <v-btn 
              v-show=collect_ytb_val 
                  class="mx-2 elevation-0" 
                  dark 
                  outlined 
                  icon 
                  :color="collect_ytb_val === false ? 'grey' : '#0471A5'"  
                  @click="collect_ytb_val !== false && $emit('toggle-collection', item, index, 'YOUTUBE')"
                >
                  <v-icon class="rounded-icon">{{ item.checkytb == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
              </v-btn>
              <v-btn 
              v-show=collect_tiktok_val 
                  class="mx-2 elevation-0" 
                  dark 
                  outlined 
                  icon 
                  :color="collect_tiktok_val === false ? 'grey' : '#0471A5'"  
                  @click="collect_tiktok_val !== false && $emit('toggle-collection', item, index, 'TIKTOK')"
                >
                  <v-icon class="rounded-icon">{{ item.checktiktok== true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
              </v-btn>
              <v-btn 
              v-show=collect_ig_val
                  class="mx-2 elevation-0" 
                  dark 
                  outlined 
                  icon 
                  :color="collect_ig_val === false ? 'grey' : '#0471A5'"  
                  @click="collect_ig_val !== false && $emit('toggle-collection', item, index, 'INSTAGRAM')"
                >
                  <v-icon class="rounded-icon">{{ item.checkig == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
              </v-btn>
              <v-btn 
              v-show=collect_fb_val
                  class="mx-2 elevation-0" 
                  dark 
                  outlined 
                  icon 
                  :color="collect_fb_val === false ? 'grey' : '#0471A5'"  
                  @click="collect_fb_val !== false && $emit('toggle-collection', item, index, 'FACEBOOK')"
                >
                  <v-icon class="rounded-icon">{{ item.checkfb == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
              </v-btn>
              <v-btn 
                :class="{
                  'red darken-1': keywordstatus !== 0,
                  'grey darken-1': keywordstatus === 0
                }"
                :color="keywordstatus === 0 ? '#fff' : '#fff'"  
                @click="keywordstatus !== 0 && $emit('remove-keyword', item, index)"
                icon>
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </v-flex>
          </v-row>
            <v-col cols="12" sm="12" md="12">
              <v-btn 
              v-show=buttonAddKeyword
              :color="keywordstatus === 0 ? 'grey' : 'blue darken-1'"
              style="width: 160px;" rounded dark dense  
                @click="keywordstatus === 0 ? '' : $emit('add-keyword')"
              
              >
                <v-icon>mdi-plus</v-icon> Add Keywords
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="py-3">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
          Cancel 
        </v-btn>
        <v-btn v-show="keywordstatus !== 0"  color="blue darken-1" style="width: 90px;" rounded dark dense @click="$emit('save')">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    item_edit_keyword_dinamis: { type: Array, default: () => [] },
    keywordstatus: { type: Number, default: 1 },
    name_topic_dialog: { type: String, default: '' },
    width_form_keyword: { type: String, default: '400px' },
    collect_news_val: { type: Boolean, default: false },
    collect_twit_val: { type: Boolean, default: false },
    collect_ytb_val: { type: Boolean, default: false },
    collect_tiktok_val: { type: Boolean, default: false },
    collect_ig_val: { type: Boolean, default: false },
    collect_fb_val: { type: Boolean, default: false },
    buttonAddKeyword: { type: Boolean, default: true }
  },
  computed: {
    dialogVisible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  methods: {
    close() {
      this.dialogVisible = false
    }
  }
}
</script>
